import { useEffect } from "react";
import { useWorkspaceContextStore } from "@presentation/stores/WorkspaceContextStore";
import { useRecentlyVisitedStore } from "@presentation/stores/RecentlyVisitedStore";

/**
Records a visit to a project (settings, job setup, or jobs) for the Home page's recently-
visited list, once the project/team names are available from the already-hydrated workspace context.
*/
export const useRecordProjectVisit = (teamId: string, projectId: string): void => {
  const projectName = useWorkspaceContextStore((state) => state.projects.find((project) => project.id === projectId)?.name ?? null);
  const teamName = useWorkspaceContextStore((state) => state.teams.find((team) => team.id === teamId)?.name ?? null);
  const recordProjectVisit = useRecentlyVisitedStore((state) => state.recordProjectVisit);

  useEffect(() => {
    if (teamId && projectId && projectName) recordProjectVisit({ teamId, projectId, projectName, teamName: teamName ?? teamId });
  }, [teamId, projectId, projectName, teamName, recordProjectVisit]);
};
